import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=a61218ce&scoped=true&"
import script from "./SearchIndex.vue?vue&type=script&lang=js&"
export * from "./SearchIndex.vue?vue&type=script&lang=js&"
import style0 from "./SearchIndex.vue?vue&type=style&index=0&id=a61218ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61218ce",
  null
  
)

export default component.exports